import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import Service from '../../../services/index';
import { baseUrlAdmin } from '../../../store/apiConstants';
import LoadingComponent from '../../loadingComponent';
import BranchToSectionMultiDDTillSecReports from "../../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports";
import { Message as InfoMessage } from 'primereact/message';
import TransactionHistoryTable from '../TransactionHistoryTable';
import * as XLSX from 'xlsx';
import Authorizer from '../../session/authorizer';
import { PERMISSIONS } from '../../../session/authorize';
import './style.scss';

class FinanceBulkUpload extends Component {
    constructor(props) {
        super(props);
        this.service = new Service();
        this.toast = React.createRef();
        this.fileUploadRef = React.createRef();
        this.transactionHistoryRef = React.createRef();
        this.state = {
            loading: false,
            uploadResults: null,
            dropdownsData: {},
            selectedAcademicYear: null,
            globalAcademicYear: localStorage.getItem('userAcademicYear'),
            validationErrors: [],
            validationInProgress: false,
            uploadInProgress: false,
            downloadInProgress: false,
            selectedFile: null,
            originalCSVData: null,
            csvHeaders: null
        };
    }

    componentDidMount() {
        window.addEventListener('storage', this.handleStorageChange);
        window.addEventListener('academicYearChanged', this.handleCustomAyChange);

        const currentAy = localStorage.getItem('userAcademicYear');
        if (currentAy) {
            this.setState({ globalAcademicYear: currentAy });
        }
    }

    componentDidUpdate(prevProps) {
        // Component updated
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
        window.removeEventListener('academicYearChanged', this.handleCustomAyChange);
    }

    handleStorageChange = (e) => {
        if (e.key === 'userAcademicYear') {
            this.setState({ globalAcademicYear: e.newValue });
        }
    };

    handleCustomAyChange = (e) => {
        const { academicYearId } = e.detail;
        this.setState({ globalAcademicYear: academicYearId });
    }

    csvToJSON = (csv) => {
        const lines = csv.split('\n');
        if (lines.length < 1) return [];
        const headers = lines[0].split(',').map(h => h.trim());
        const result = [];

        for (let i = 1; i < lines.length; i++) {
            let line = lines[i].trim();
            if (!line) continue;
            
            const rowData = [];
            let currentVal = '';
            let insideQuote = false;
            
            for(let charIndex = 0; charIndex < line.length; charIndex++){
                const char = line[charIndex];
                if(char === '"'){
                    insideQuote = !insideQuote; // Toggle
                } else if(char === ',' && !insideQuote){
                    rowData.push(currentVal.trim());
                    currentVal = '';
                } else {
                    currentVal += char;
                }
            }
            rowData.push(currentVal.trim()); // Last val

            const obj = {};
            let hasData = false;

            for (let j = 0; j < headers.length; j++) {
                let val = rowData[j];
                // Remove quotes from values
                if(val && val.startsWith('"') && val.endsWith('"')) val = val.slice(1, -1);
                
                obj[headers[j]] = val;
                if(val) hasData = true;
            }

            if(hasData) result.push(obj);
        }
        return result;
    }

    // Process and Validate Records
    processRecords = (records) => {
        const validRecords = [];
        const errors = [];
        
        // Allowed payment modes
        const allowedPaymentModes = ['CSH', 'ONL', 'CC', 'DC', 'QR', 'CHQ', 'DD'];
        
        records.forEach((row, index) => {
            const clean = (key) => (row[key] || '').trim();
            const rowNum = index + 2; // 1-based index + header

            // 1. Skip Empty/Zero Amount
            let amount = row['amount paying'];
            if (!amount || amount === '' || amount === '0') return; 
            
            amount = parseFloat(amount);
            if (isNaN(amount) || amount <= 0) return;

            // 2. Map Keys (Snake Case)
            const payload = {
                user_id: clean('UserId'),
                branch_id: clean('BranchId'),
                board_id: clean('BoardId'),
                grade_id: clean('GradeId'),
                section_id: clean('SectionId'),
                academic_year_id: clean('AcademicYearId'),
                fee_type_id: clean('FeeTypeId'),
                installment_id: clean('InstallmentId'),
                
                // Metadata for recovery (Names)
                student_name: clean('studentName'),
                branch_name: clean('branch'),
                board_name: clean('board'),
                grade_name: clean('grade'),
                section_name: clean('section'),
                academic_year_name: clean('academicYear'),
                fee_type_name: clean('fee Type'),
                installment_name: clean('installment'),
                total_fee: clean('total fee'),
                paid: clean('paid'),
                due_amount: clean('Due amount'),
                
                amount_paying: amount,
                payment_mode: clean('payment mode(CSH/ONL/CC/DC/QR/CHQ/DD)'),
                
                transaction_date: clean('transaction date'),
                receipt_date: clean('receipt date'),
                
                remarks: clean('Remarks'),
                
                // Conditional Fields - Credit/Debit Card
                transaction_id: clean('TransactionId'),
                card_no: clean('CardLast4Digits'),
                approval_code: clean('ApprovalCode'),
                user_bank_name: clean('CardBankName'),
                rr_number: clean('RRNumber'),
                
                // Conditional Fields - Cheque
                cheque_no: clean('ChequeNo'),
                cheque_issued_to: clean('ChequeIssuedTo'),
                cheque_date: clean('ChequeDate'),
                
                // Conditional Fields - DD
                dd_no: clean('DDNo'),
                dd_issued_to: clean('DDIssuedTo'),
                dd_date: clean('DDDate'),
                
                // Common Fields - Cheque/DD
                bank_name: clean('BankName'),
                bank_branch: clean('BankBranchName'),
                
                // Meta for error reporting
                admission_no: clean('enrollment No') || clean('UserId'),
                
                // IMPORTANT: Store original CSV row for error sheet recovery
                _originalRow: { ...row }
            };

            // 3. Validations
            const rowErrors = [];
            const missingFields = [];

            // Check required fields with friendly names
            if (!payload.user_id) missingFields.push('User ID');
            if (!payload.installment_id) missingFields.push('Installment ID');
            if (!payload.fee_type_id) missingFields.push('Fee Type ID');
            if (!payload.academic_year_id) missingFields.push('Academic Year ID');
            
            if (missingFields.length > 0) {
                rowErrors.push(`Missing required fields: ${missingFields.join(', ')}`);
            }

            // Amount Validation
            if (!payload.amount_paying || payload.amount_paying <= 0) {
                rowErrors.push('Amount Paying must be greater than 0');
            }

            // Date Validation
            if (!payload.transaction_date) {
                rowErrors.push('Transaction Date is required');
            } else {
                // Check if transaction date is not in future
                const parseDate = (dateStr) => {
                    if (!dateStr) return null;
                    // Handle DD-MM-YYYY format
                    const parts = dateStr.split('-');
                    if (parts.length === 3) {
                        return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
                    }
                    return new Date(dateStr);
                };
                
                const txnDate = parseDate(payload.transaction_date);
                const today = new Date();
                today.setHours(23, 59, 59, 999); // End of today
                
                if (txnDate && txnDate > today) {
                    rowErrors.push(`Transaction Date (${payload.transaction_date}) cannot be in the future`);
                }
            }
            
            if (!payload.receipt_date) {
                rowErrors.push('Receipt Date is required');
            } else {
                // Check if receipt date is not in future
                const parseDate = (dateStr) => {
                    if (!dateStr) return null;
                    const parts = dateStr.split('-');
                    if (parts.length === 3) {
                        return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
                    }
                    return new Date(dateStr);
                };
                
                const rcptDate = parseDate(payload.receipt_date);
                const today = new Date();
                today.setHours(23, 59, 59, 999);
                
                if (rcptDate && rcptDate > today) {
                    rowErrors.push(`Receipt Date (${payload.receipt_date}) cannot be in the future`);
                }
            }
            
            // Amount vs Due Validation (client-side warning)
            if (payload.due_amount && payload.amount_paying) {
                const dueAmount = parseFloat(payload.due_amount);
                if (!isNaN(dueAmount) && payload.amount_paying > dueAmount + 1) {
                    rowErrors.push(`Amount Paying (₹${payload.amount_paying}) exceeds Due Amount (₹${dueAmount}). Please verify.`);
                }
            }

            // Payment Mode Validation
            if (!payload.payment_mode) {
                rowErrors.push('Payment Mode is required (Valid: CSH, ONL, CC, DC, QR, CHQ, DD)');
            } else {
                const mode = payload.payment_mode.toUpperCase().trim();
                
                // Check if payment mode is valid
                if (!allowedPaymentModes.includes(mode)) {
                    rowErrors.push(`Invalid Payment Mode "${payload.payment_mode}". Valid values: ${allowedPaymentModes.join(', ')}`);
                } else {
                    // Normalize payment mode
                    payload.payment_mode = mode;
                    
                    // Mode-specific validations with clear error messages
                    switch (mode) {
                        case 'CSH': // Cash
                            // No additional fields required - transaction ID is optional for cash
                            break;
                            
                        case 'ONL': // Online
                        case 'QR': // QR Code
                            if (!payload.transaction_id) {
                                rowErrors.push(`Transaction ID is required for ${mode} payment`);
                            }
                            break;
                            
                        case 'CC': // Credit Card
                        case 'DC': // Debit Card
                            const cardMissingFields = [];
                            if (!payload.transaction_id) cardMissingFields.push('Transaction ID');
                            if (!payload.card_no) cardMissingFields.push('Card Last 4 Digits');
                            if (!payload.approval_code) cardMissingFields.push('Approval Code');
                            if (!payload.user_bank_name) cardMissingFields.push('Card Bank Name');
                            if (!payload.rr_number) cardMissingFields.push('RR Number');
                            
                            if (cardMissingFields.length > 0) {
                                rowErrors.push(`${mode} payment requires: ${cardMissingFields.join(', ')}`);
                            }
                            break;
                            
                        case 'CHQ': // Cheque
                            const chequeMissingFields = [];
                            if (!payload.cheque_no) chequeMissingFields.push('Cheque Number');
                            if (!payload.cheque_issued_to) chequeMissingFields.push('Cheque Issued To');
                            if (!payload.cheque_date) chequeMissingFields.push('Cheque Date');
                            if (!payload.bank_name) chequeMissingFields.push('Bank Name');
                            if (!payload.bank_branch) chequeMissingFields.push('Bank Branch Name');
                            
                            if (chequeMissingFields.length > 0) {
                                rowErrors.push(`Cheque payment requires: ${chequeMissingFields.join(', ')}`);
                            }
                            break;
                            
                        case 'DD': // Demand Draft
                            const ddMissingFields = [];
                            if (!payload.dd_no) ddMissingFields.push('DD Number');
                            if (!payload.dd_issued_to) ddMissingFields.push('DD Issued To');
                            if (!payload.dd_date) ddMissingFields.push('DD Date');
                            if (!payload.bank_name) ddMissingFields.push('Bank Name');
                            if (!payload.bank_branch) ddMissingFields.push('Bank Branch Name');
                            
                            if (ddMissingFields.length > 0) {
                                rowErrors.push(`DD payment requires: ${ddMissingFields.join(', ')}`);
                            }
                            break;
                    }
                }
            }

            if (rowErrors.length > 0) {
                const studentInfo = payload.student_name ? ` (${payload.student_name})` : '';
                const enrollmentInfo = payload.admission_no ? ` | Enrollment: ${payload.admission_no}` : '';
                
                errors.push({ 
                    row: rowNum,
                    AdmissionNo: payload.admission_no || 'N/A',
                    studentName: payload.student_name || 'Unknown',
                    error: rowErrors.join(' | '),
                    details: `Row ${rowNum}${studentInfo}${enrollmentInfo}: ${rowErrors.join('; ')}`
                });
            } else {
                validRecords.push(payload);
            }
        });

        return { validRecords, errors };
    }

    onFileSelect = async (event, type) => {
        const file = event.files[0];
        if (!file) {
            this.showToast('warn', 'No File', 'Please select a file to upload');
            return;
        }

        // CRITICAL: Clear file upload component first to ensure fresh state
        if (this.fileUploadRef.current) {
            this.fileUploadRef.current.clear();
        }

        // Reset ALL state before processing new file
        this.setState({ 
            selectedFile: file,
            validationInProgress: true,
            validationErrors: [],
            uploadResults: null,
            originalCSVData: null,
            csvHeaders: null,
            uploadInProgress: false
        });

        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                const csvText = e.target.result;
                const rawRecords = this.csvToJSON(csvText);
                
                if (rawRecords.length === 0) {
                    this.showToast('warn', 'Empty File', 'The CSV file appears to be empty.');
                    this.setState({ validationInProgress: false, selectedFile: null });
                    return;
                }

                // Store original CSV data and headers for error sheet
                const lines = csvText.split('\n');
                const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));
                
                this.setState({
                    originalCSVData: rawRecords,
                    csvHeaders: headers
                });

                // Process records for client-side validation
                const { validRecords, errors } = this.processRecords(rawRecords);

                if (errors.length > 0) {

                    
                    this.setState({ 
                        validationErrors: errors,
                        validationInProgress: false,
                        selectedFile: null
                    });
                    
                    // Clear file upload component
                    if (this.fileUploadRef.current) {
                        this.fileUploadRef.current.clear();
                    }
                    
                    // Show specific error summary in toast
                    const errorSummary = errors.length === 1 
                        ? `1 validation error found in the file`
                        : `${errors.length} validation errors found in the file`;
                    
                    this.showToast('error', 'Validation Failed', 
                        `${errorSummary}. Review errors below and fix them before re-uploading.`);
                    return;
                }

                this.setState({ validationInProgress: false });
                
                // Upload to server for DB validation
                await this.uploadToServer(validRecords);

            } catch (error) {
                console.error('File processing error:', error);
                this.showToast('error', 'Error', error?.message || 'Failed to process file');
                
                // Clear file upload component
                if (this.fileUploadRef.current) {
                    this.fileUploadRef.current.clear();
                }
                
                this.setState({ 
                    validationInProgress: false,
                    uploadInProgress: false,
                    selectedFile: null,
                    originalCSVData: null,
                    csvHeaders: null
                });
            }
        };
        reader.readAsText(file);
    };

    uploadToServer = async (validRecords) => {
        this.setState({ uploadInProgress: true });
        try {
            const url = `${baseUrlAdmin}/finance-upload/payments`;

            const payload = {
                records: validRecords,
                orgId: this.props.orgId,
                academicYear: this.state.globalAcademicYear,
                uploadedBy: localStorage.getItem('user_id'),
                uploadedByName: localStorage.getItem('userName') || 'Admin',
                originalCSVData: this.state.originalCSVData,
                csvHeaders: this.state.csvHeaders
            };



            const response = await this.service.post(url, payload, true);
            

            
            // Handle undefined or null response
            if (!response) {
                throw new Error('No response received from server');
            }
            
            // Check if service returned an error (status: false)
            if (response.status === false) {
                const errorMsg = response.errMessage || response.message || 'Request failed';
                throw new Error(errorMsg);
            }
            




            
            // Extract the actual result with multiple fallback strategies
            // Backend returns: { success: true, message: "...", data: { success: count, failed: count, ... } }
            // Service wraps it: { status: true, res: <above> }
            let result = null;
            
            // Strategy 1: Service wrapped + Backend wrapped { status: true, res: { success: true, data: {...} } }
            if (response?.res?.data && typeof response.res.data === 'object') {
                result = response.res.data;

            }
            // Strategy 2: Service response is direct backend response
            else if (response?.data && typeof response.data === 'object') {
                result = response.data;

            }
            // Strategy 3: Response itself is the result (direct axios response)
            else if (response?.success !== undefined || response?.failed !== undefined) {
                result = response;

            }
            // Strategy 4: res object contains the counts directly
            else if (response?.res && (response.res.success !== undefined || response.res.failed !== undefined)) {
                result = response.res;

            }
            
            // If still no result, create a default error object
            if (!result) {
                console.error('Could not extract result from response:', response);
                throw new Error('Invalid response format from server');
            }
            







            
            // Check for validation failure
            if (result?.validationFailed || (result?.errors && result.errors.length > 0)) {

                
                // Clear file upload component first
                if (this.fileUploadRef.current) {
                    this.fileUploadRef.current.clear();
                }
                
                this.setState({
                    validationErrors: result.errors || result.validationDetails || [],
                    uploadInProgress: false,
                    selectedFile: null,
                    originalCSVData: null,
                    csvHeaders: null
                }, () => {

                    if (this.transactionHistoryRef.current) {
                        this.transactionHistoryRef.current.loadTransactionHistory();
                    }
                });
                
                this.showToast('error', 'Validation Failed', 
                    result.message || `Found ${result.errors?.length || 0} validation errors. Download error sheet from transaction history.`);
                return;
            }

            // Success - payments processed


            
            // Extract success/failed counts from various possible locations
            const successCount = result.success || result.successCount || validRecords.length || 0;
            const failedCount = result.failed || result.failedCount || 0;
            const receiptsCreated = result.receiptsCreated || [];
            



            
            // Clear file upload component
            if (this.fileUploadRef.current) {
                this.fileUploadRef.current.clear();
            }
            
            // For successful upload, DON'T show uploadResults card - just show toast and update history
            this.setState({
                uploadResults: null, // Clear results card for success - history table will show the record
                uploadInProgress: false,
                selectedFile: null,
                originalCSVData: null,
                csvHeaders: null,
                validationErrors: []
            }, () => {
                // Reload transaction history from DB to show the new record
                if (this.transactionHistoryRef.current) {
                    this.transactionHistoryRef.current.loadTransactionHistory();
                }
            });
            
            // Show success toast with details
            const receiptInfo = receiptsCreated.length > 0 
                ? ` ${receiptsCreated.length} receipt(s) generated.`
                : '';
            this.showToast('success', 'Upload Successful', 
                `Successfully processed ${successCount} payment(s).${receiptInfo}`);

        } catch (error) {
            console.error('=== UPLOAD ERROR ===');
            console.error('Upload error:', error);
            console.error('Error message:', error?.message);
            console.error('Error response:', error?.response);
            console.error('Error response data:', error?.response?.data);
            
            // Clear file upload component first
            if (this.fileUploadRef.current) {
                this.fileUploadRef.current.clear();
            }
            
            // Check if error response has validation failure data
            const errorData = error?.response?.data || error?.data;
            if (errorData) {
                const result = errorData.data || errorData;

                
                if (result?.validationFailed || (result?.errors && result.errors.length > 0)) {

                    
                    this.setState({
                        validationErrors: result.errors || result.validationDetails || [],
                        uploadInProgress: false,
                        selectedFile: null,
                        originalCSVData: null,
                        csvHeaders: null
                    }, () => {

                        if (this.transactionHistoryRef.current) {
                            this.transactionHistoryRef.current.loadTransactionHistory();
                        }
                    });
                    
                    this.showToast('error', 'Validation Failed', 
                        result.message || `Found ${result.errors?.length || 0} validation errors. Download error sheet from transaction history.`);
                    return;
                }
            }
            
            // Generic error handling
            const errorMessage = error?.message || error?.response?.data?.message || 'An error occurred during upload';
            this.showToast('error', 'Upload Failed', errorMessage);
            
            this.setState({ 
                uploadInProgress: false,
                selectedFile: null,
                originalCSVData: null,
                csvHeaders: null
            }, () => {
                if (this.transactionHistoryRef.current) {
                    this.transactionHistoryRef.current.loadTransactionHistory();
                }
            });
        }
    };

    downloadTemplate = async () => {
        const { dropdownsData, globalAcademicYear } = this.state;

        if (!globalAcademicYear) {
            this.showToast('warn', 'Selection Required', 'Please select Academic Year from Top Bar');
            return;
        }


        
        // Check if any selection has been made
        if (!dropdownsData || Object.keys(dropdownsData).length === 0) {
            this.showToast('warn', 'Selection Required', 'Please select Branch, Board, Class, and Section from the filters above');
            return;
        }
        
        // Strict Validation till Section - check both singular and plural keys
        const check = (keys, label) => {
             // Try multiple possible key names
             const keyArray = Array.isArray(keys) ? keys : [keys];
             let val = null;
             
             for (let key of keyArray) {
                 if (dropdownsData[key] !== undefined && dropdownsData[key] !== null) {
                     val = dropdownsData[key];
                     break;
                 }
             }
             
             if (!val || (Array.isArray(val) && val.length === 0)) {
                 this.showToast('warn', 'Selection Required', `Please select at least one ${label}`);
                 return false;
             }
             return true;
        };

        // Validate all levels down to section - check both singular and plural keys
        if(!check(['branchIds', 'branchId'], 'Branch')) return;
        if(!check(['boardIds', 'boardId'], 'Board')) return;
        if(!check(['classIds', 'classId', 'gradeIds', 'gradeId'], 'Class/Grade')) return;
        if(!check(['sectionIds', 'sectionId'], 'Section')) return;

        const params = new URLSearchParams();
        if(this.props.orgId) params.append('orgId', this.props.orgId);
        params.append('academicYear', globalAcademicYear);

        // Helper to append array or single
        const appendParam = (key, val) => {
            if(!val) return;
            if(Array.isArray(val)) {
                val.forEach(v => params.append(key, v));
            } else {
                params.append(key, val);
            }
        };

        // Use the value from whichever key exists
        appendParam('branchId', dropdownsData.branchIds || dropdownsData.branchId);
        appendParam('classId', dropdownsData.classIds || dropdownsData.classId || dropdownsData.gradeIds || dropdownsData.gradeId);
        appendParam('sectionId', dropdownsData.sectionIds || dropdownsData.sectionId);
        
        const url = `${baseUrlAdmin}/finance-upload/template-payments?${params.toString()}`;

        this.setState({ downloadInProgress: true });
        try {
            // Use axios directly to get blob, assuming Service might be expecting JSON or specific wrapper
            // We use the same token key as the Service class: 'Bearer'
            
            const token = localStorage.getItem('Bearer'); 

            if (!token) {
                 this.showToast('error', 'Auth Error', 'No active session found. Please login again.');
                 this.setState({ downloadInProgress: false });
                 return;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const downloadUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = `payments_template.csv`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(downloadUrl);
            } else {
                const errText = await response.text();
                // try parsing json
                try {
                    const errJson = JSON.parse(errText);
                    this.showToast('error', 'Download Failed', errJson.message || 'Unknown error');
                } catch(e) {
                     this.showToast('error', 'Download Failed', errText || response.statusText);
                }
            }

        } catch (error) {
            console.error('Download error:', error);
            this.showToast('error', 'Error', 'Failed to download template');
        } finally {
            this.setState({ downloadInProgress: false });
        }
    };

    showToast = (severity, summary, detail) => {
        if(this.toast.current)
            this.toast.current.show({ severity, summary, detail, life: 3000 });
    };

    downloadErrorSheet = async (transaction) => {
        try {


            
            // Fetch full transaction details with CSV data from DB
            const url = `${baseUrlAdmin}/finance-upload/transaction/${transaction._id}`;

            
            const response = await this.service.get(url, true);

            
            // Universal Response Extraction
            let transactionWrapper = null;
            if (response && response.status === true && response.res) {
                 transactionWrapper = response.res;
            } else if (response && (response.success || response.data)) {
                 transactionWrapper = response;
            } else if (response) {
                // Direct response without wrapper
                transactionWrapper = response;
            }



            if (!transactionWrapper) {
                this.showToast('error', 'Download Failed', 'Failed to fetch transaction details');
                return;
            }
            
            // Allow 'data' to be the transaction or contain 'data'
            const transactionData = transactionWrapper.data?.data || transactionWrapper.data || transactionWrapper;

            
            const errors = transactionData.errors || [];
            const originalCSVData = transactionData.originalCSVData;
            const csvHeaders = transactionData.csvHeaders;







            if (!errors || errors.length === 0) {
                this.showToast('warn', 'No Errors', 'No error details found for this transaction. It may have been successful.');
                return;
            }

            let excelData = [];
            let excelHeaders = [];

            // Case A: Full Data Avilable (Original CSV exists)
            if (originalCSVData && csvHeaders && csvHeaders.length > 0) {
                // Create error map for quick lookup - handle both client and server error formats
                const errorMap = new Map();
                



                
                errors.forEach((err, idx) => {
                    // Handle different error formats
                    const admNo = err.admission_no || err.AdmissionNo || err.user_id || '';
                    
                    // Extract error messages
                    let errorMessages = [];
                    if (Array.isArray(err.errors)) {
                        errorMessages = err.errors;
                    } else if (err.error) {
                        errorMessages = [err.error];
                    } else if (err.message) {
                        errorMessages = [err.message];
                    } else {
                        errorMessages = ['Validation error'];
                    }
                    
                    // Strategy 1: Match by admission number / user_id
                    if (admNo) {
                        const key1 = `admno_${admNo}`;
                        if (!errorMap.has(key1)) {
                            errorMap.set(key1, []);
                        }
                        errorMap.get(key1).push(...errorMessages);
                    }
                    
                    // Strategy 2: Match by user_id field if different from admNo
                    if (err.user_id && err.user_id !== admNo) {
                        const key1b = `admno_${err.user_id}`;
                        if (!errorMap.has(key1b)) {
                            errorMap.set(key1b, []);
                        }
                        errorMap.get(key1b).push(...errorMessages);
                    }
                    
                    // Strategy 3: Match by row number if available
                    if (err.row) {
                        const key2 = `row_${err.row}`;
                        if (!errorMap.has(key2)) {
                            errorMap.set(key2, []);
                        }
                        errorMap.get(key2).push(...errorMessages);
                    }
                });

                // Add "Error Reason" column to headers
                excelHeaders = [...csvHeaders, 'Error Reason'];

                // Map original data with error messages
                excelData = originalCSVData.map((row, index) => {
                    // Try multiple field names for admission number
                    const admissionNo = row['enrollment No'] || row['UserId'] || row.admission_no || row['Admission No'] || row.AdmissionNo || row.user_id || '';
                    const csvRowNum = index + 1;
                    
                    // Try to find errors for this row using multiple strategies
                    let errorMessages = [];
                    
                    // Strategy 1: Match by admission number
                    const key1 = `admno_${admissionNo}`;
                    if (errorMap.has(key1)) {
                        errorMessages.push(...errorMap.get(key1));
                    }
                    
                    // Strategy 1b: Match by UserId field if present in row
                    const userId = row['UserId'] || row.user_id || '';
                    if (userId && userId !== admissionNo) {
                        const key1b = `admno_${userId}`;
                        if (errorMap.has(key1b)) {
                            errorMessages.push(...errorMap.get(key1b));
                        }
                    }
                    
                    // Strategy 2: Match by CSV row number
                    const key2 = `row_${csvRowNum}`;
                    if (errorMap.has(key2)) {
                        errorMessages.push(...errorMap.get(key2));
                    }
                    
                    // Remove duplicates
                    errorMessages = [...new Set(errorMessages)];
                    
                    const errorText = errorMessages.length > 0 ? errorMessages.join('; ') : 'Valid';

                    // Create row with all original data plus error message
                    const rowData = {};
                    csvHeaders.forEach(header => {
                        rowData[header] = row[header] || '';
                    });
                    rowData['Error Reason'] = errorText;

                    return rowData;
                });
            } else {
                // Case B: Metadata Only (Original CSV missing due to size limits or error)
                // Generate a template-like sheet so user can fix and re-upload

                
                // Standard Payment Template Headers (matching backend financeGenericBulkUpload.js)
                const standardHeaders = [
                    'UserId', 'BranchId', 'BoardId', 'GradeId', 'SectionId', 'AcademicYearId', 'FeeTypeId', 'InstallmentId',
                    'branch', 'board', 'grade', 'section', 'academicYear', 
                    'enrollment No', 'studentName',
                    'fee Type', 'installment', 'total fee', 'paid', 'Due amount',
                    'amount paying', 'transaction date', 'receipt date', 'payment mode(CSH/ONL/CC/DC/QR/CHQ/DD)',
                    'TransactionId', 'ChequeNo', 'ChequeDate', 'ChequeIssuedTo', 'DDNo', 'DDDate', 'DDIssuedTo', 'BankName', 'BankBranchName',
                    'CardLast4Digits', 'ApprovalCode', 'RRNumber', 'CardBankName',
                    'Remarks'
                ];
                
                excelHeaders = [...standardHeaders, 'Error Reason'];
                
                excelData = errors.map((err, index) => {


                     if (err.record) {


                     }
                     
                     const admNo = err.admission_no || err.AdmissionNo || err.user_id || '';
                     
                     let errorText = '';
                     if (Array.isArray(err.errors)) {
                         errorText = err.errors.join('; ');
                     } else if (err.error) {
                         errorText = err.error;
                     } else {
                         errorText = 'Validation Failed';
                     }
                     
                     // Create a row with all standard headers (empty by default)
                     const rowData = {};
                     standardHeaders.forEach(h => rowData[h] = '');
                     
                     // Fill known fields to help the user identify the record
                     // We map admission_no to UserId as that is the primary identifier in the template
                     rowData['UserId'] = admNo; 
                     rowData['enrollment No'] = admNo;
                     rowData['Error Reason'] = errorText;

                     // If full record data is available in the error object (recovery mode), populate the row
                     if (err.record) {
                        const rec = err.record;
                        
                        // PRIORITY 1: Use original CSV row if available (best data source)
                        if (rec._originalRow) {
                            const origRow = rec._originalRow;
                            standardHeaders.forEach(header => {
                                if (origRow[header] !== undefined && origRow[header] !== null && origRow[header] !== '') {
                                    rowData[header] = origRow[header];
                                }
                            });
                        }
                        
                        // PRIORITY 2: Map normalized backend keys back to Template Headers (fallback)
                        const fieldMap = {
                            'UserId': 'user_id',
                            'BranchId': 'branch_id',
                            'BoardId': 'board_id',
                            'GradeId': 'grade_id',
                            'SectionId': 'section_id',
                            'AcademicYearId': 'academic_year_id',
                            'FeeTypeId': 'fee_type_id',
                            'InstallmentId': 'installment_id',

                            'branch': 'branch_name',
                            'board': 'board_name',
                            'grade': 'grade_name',
                            'section': 'section_name',
                            'academicYear': 'academic_year_name',
                            'studentName': 'student_name',
                            'fee Type': 'fee_type_name',
                            'installment': 'installment_name',
                            'total fee': 'total_fee',
                            'paid': 'paid',
                            'Due amount': 'due_amount',

                            'amount paying': 'amount_paying',
                            'payment mode(CSH/ONL/CC/DC/QR/CHQ/DD)': 'payment_mode',
                            'transaction date': 'transaction_date',
                            'receipt date': 'receipt_date',
                            'Remarks': 'remarks',
                            'TransactionId': 'transaction_id',
                            'CardLast4Digits': 'card_no',
                            'ApprovalCode': 'approval_code',
                            'CardBankName': 'user_bank_name',
                            'RRNumber': 'rr_number',
                            'ChequeNo': 'cheque_no',
                            'ChequeIssuedTo': 'cheque_issued_to',
                            'ChequeDate': 'cheque_date',
                            'DDNo': 'dd_no',
                            'DDIssuedTo': 'dd_issued_to',
                            'DDDate': 'dd_date',
                            'BankName': 'bank_name',
                            'BankBranchName': 'bank_branch'
                        };
                        
                        Object.keys(fieldMap).forEach(templateHeader => {
                            const backendKey = fieldMap[templateHeader];
                            if (rec[backendKey] !== undefined && rec[backendKey] !== null) {
                                rowData[templateHeader] = rec[backendKey];
                            }
                        });
                        
                        // Special handling for UserId if admission_no is different or present
                        if (rec.admission_no) {
                            rowData['enrollment No'] = rec.admission_no;
                        }
                     }
                     
                     return rowData;
                });
            }




            if (excelData.length === 0) {
                this.showToast('warn', 'No Data', 'No error data to export');
                return;
            }

            // Create worksheet
            const ws = XLSX.utils.json_to_sheet(excelData, { header: excelHeaders });

            // Auto-size columns
            const colWidths = excelHeaders.map(header => ({
                wch: Math.max(
                    15,
                    header.length,
                    ...excelData.map(row => String(row[header] || '').length)
                )
            }));
            ws['!cols'] = colWidths;

            // Create workbook and export
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Validation Errors');

            const uploadDate = transactionData.uploadDate ? new Date(transactionData.uploadDate) : new Date();
            const fileName = `Payment_Upload_Errors_${uploadDate.toISOString().split('T')[0]}.xlsx`;

            
            XLSX.writeFile(wb, fileName);

            this.showToast('success', 'Downloaded', 'Error sheet downloaded successfully. Fix errors and re-upload.');

        } catch (error) {
            console.error('Error sheet download failed:', error);
            console.error('Error stack:', error.stack);
            this.showToast('error', 'Download Failed', `Failed to generate error sheet: ${error.message}`);
        }
    };

    renderValidationErrorsTable() {
        const { validationErrors } = this.state;

        if (!validationErrors || validationErrors.length === 0) {
            return null;
        }

        return (
            <Card className="validation-errors-card p-mt-3" title="⚠️ Validation Errors" style={{ borderLeft: '4px solid #f44336' }}>
                <div className="p-mb-3">
                    <Message 
                        severity="error" 
                        text={`Found ${validationErrors.length} validation error(s). Please fix the issues below and re-upload the file.`} 
                    />
                </div>
                
                <DataTable 
                    value={validationErrors} 
                    paginator 
                    rows={10} 
                    className="p-datatable-sm"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    emptyMessage="No validation errors"
                >
                    <Column 
                        field="row" 
                        header="Row #" 
                        style={{ width: '80px', fontWeight: 'bold' }}
                        body={(rowData) => (
                            <span style={{ color: '#f44336', fontWeight: 'bold' }}>#{rowData.row}</span>
                        )}
                    />
                    <Column 
                        field="studentName" 
                        header="Student" 
                        style={{ width: '150px' }}
                        body={(rowData) => (
                            <div>
                                <div style={{ fontWeight: '500' }}>{rowData.studentName || 'Unknown'}</div>
                                <small style={{ color: '#666' }}>({rowData.AdmissionNo || 'N/A'})</small>
                            </div>
                        )}
                    />
                    <Column 
                        field="error" 
                        header="Error Details" 
                        body={(rowData) => (
                            <div style={{ color: '#d32f2f' }}>
                                {rowData.error.split(' | ').map((err, idx) => (
                                    <div key={idx} style={{ marginBottom: '4px' }}>
                                        <i className="pi pi-times-circle" style={{ marginRight: '6px', fontSize: '12px' }}></i>
                                        <span>{err}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    />
                </DataTable>
                
                <div className="p-mt-3" style={{ padding: '12px', backgroundColor: '#fff3e0', borderLeft: '4px solid #ff9800', borderRadius: '4px' }}>
                    <p style={{ margin: 0, fontSize: '14px' }}>
                        <i className="pi pi-info-circle" style={{ marginRight: '8px', color: '#ff9800' }}></i>
                        <strong>How to fix:</strong> Correct the errors in your CSV file and upload again. Make sure all required fields are filled correctly.
                    </p>
                </div>
            </Card>
        );
    }

    renderValidationErrorsTable() {
        const { validationErrors } = this.state;

        if (!validationErrors || validationErrors.length === 0) {
            return null;
        }

        return (
            <Card className="validation-errors-card p-mt-3" title="⚠️ Validation Errors" style={{ borderLeft: '4px solid #f44336' }}>
                <div className="p-mb-3">
                    <Message 
                        severity="error" 
                        text={`Found ${validationErrors.length} validation error(s). Please fix the issues below and re-upload the file.`} 
                    />
                </div>
                
                <DataTable 
                    value={validationErrors} 
                    paginator 
                    rows={10} 
                    className="p-datatable-sm"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    emptyMessage="No validation errors"
                >
                    <Column 
                        field="row" 
                        header="Row #" 
                        style={{ width: '80px', fontWeight: 'bold' }}
                        body={(rowData) => (
                            <span style={{ color: '#f44336', fontWeight: 'bold' }}>#{rowData.row}</span>
                        )}
                    />
                    <Column 
                        field="studentName" 
                        header="Student" 
                        style={{ width: '180px' }}
                        body={(rowData) => (
                            <div>
                                <div style={{ fontWeight: '500' }}>{rowData.studentName || 'Unknown'}</div>
                                <small style={{ color: '#666' }}>({rowData.AdmissionNo || 'N/A'})</small>
                            </div>
                        )}
                    />
                    <Column 
                        field="error" 
                        header="Error Details" 
                        body={(rowData) => (
                            <div style={{ color: '#d32f2f' }}>
                                {rowData.error.split(' | ').map((err, idx) => (
                                    <div key={idx} style={{ marginBottom: '4px' }}>
                                        <i className="pi pi-times-circle" style={{ marginRight: '6px', fontSize: '12px' }}></i>
                                        <span>{err}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    />
                </DataTable>
                
                <div className="p-mt-3" style={{ padding: '12px', backgroundColor: '#fff3e0', borderLeft: '4px solid #ff9800', borderRadius: '4px' }}>
                    <p style={{ margin: 0, fontSize: '14px' }}>
                        <i className="pi pi-info-circle" style={{ marginRight: '8px', color: '#ff9800' }}></i>
                        <strong>How to fix:</strong> Correct the errors in your CSV file and upload again. Make sure all required fields are filled correctly.
                    </p>
                </div>
            </Card>
        );
    }

    renderTransactionHistory() {
        return <TransactionHistoryTable ref={this.transactionHistoryRef} {...this.props} showCard={true} />;
    }

    renderResultsTable() {
        const { uploadResults } = this.state;

        if (!uploadResults) {
            return null;
        }

        const { success, failed, errors } = uploadResults;

        return (
            <Card className="result-card p-mt-2" title="Upload Summary">
                <div className="p-grid p-mb-3">
                     <div className="p-col-12 p-md-6">
                        <Message severity="success" text={`Successfully Processed: ${success}`} />
                    </div>
                    <div className="p-col-12 p-md-6">
                        <Message severity="error" text={`Failed Records: ${failed}`} />
                    </div>
                </div>

                {errors && errors.length > 0 && (
                    <div className="p-mt-2">
                        <h5>Error Details</h5>
                        <DataTable value={errors} paginator rows={10} className="p-datatable-sm">
                            <Column field="AdmissionNo" header="Admission No" style={{width: '150px'}}></Column>
                            <Column field="error" header="Error Reason" body={(rowData) => <span style={{color:'red'}}>{rowData.error}</span>}></Column>
                        </DataTable>
                    </div>
                )}
            </Card>
        );
    }

    render() {
        const { loading, globalAcademicYear, validationInProgress, uploadInProgress, downloadInProgress, uploadHistory } = this.state;
        


        
        if (loading) return <LoadingComponent />;

        const isProcessing = validationInProgress || uploadInProgress || downloadInProgress;

        return (
            <div className="finance-bulk-upload">
                <Toast ref={this.toast} position="bottom-right" />
                
                <Card title="Finance Bulk Payment Upload" className="p-mb-3">
                    {!globalAcademicYear && (
                        <div className="p-mb-2">
                             <InfoMessage severity="warn" text="Please select an Academic Year from the top bar to proceed." />
                        </div>
                    )}
                    
                    <div className="p-fluid">
                         <BranchToSectionMultiDDTillSecReports 
                            setValues={(values) => this.setState({ dropdownsData: values })}
                            {...this.props}
                         />
                    </div>
                </Card>

                <Card title="💳 Upload Payments" className="upload-section">
                    <div className="p-grid">
                        <div className="p-col-12 p-md-6">
                            <h4>1. Download Payments Template</h4>
                            <p>Download list of students with their fee dues to enter payment transactions.</p>
                            <Authorizer permId={PERMISSIONS.FDE_DOWNLOAD_BULK_UPLOAD_TEMPLATE}>
                                <Button 
                                    label={downloadInProgress ? "Downloading..." : "Download Payments Template (CSV)"}
                                    icon={downloadInProgress ? "pi pi-spin pi-spinner" : "pi pi-download"}
                                    className="p-button-primary" 
                                    onClick={() => this.downloadTemplate()} 
                                    disabled={!globalAcademicYear || isProcessing} 
                                    loading={downloadInProgress}
                                />
                            </Authorizer>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <h4>2. Upload Payment Data</h4>
                            <p>Upload the filled CSV to generate receipts and update fee ledger.</p>
                            <Authorizer permId={PERMISSIONS.FDE_UPLOAD_BULK_DATA}>
                                <FileUpload 
                                    ref={this.fileUploadRef}
                                    mode="basic" 
                                    name="paymentFile" 
                                    accept=".csv" 
                                    maxFileSize={10000000} 
                                    chooseLabel={isProcessing ? "Processing..." : "Select & Validate CSV"} 
                                    className="p-mr-2"
                                    customUpload
                                    uploadHandler={(e) => this.onFileSelect(e)}
                                    auto
                                    disabled={!globalAcademicYear || isProcessing}
                                />
                            </Authorizer>
                            {validationInProgress && (
                                <div className="p-mt-2">
                                    <small><i className="pi pi-spin pi-spinner"></i> Validating data...</small>
                                </div>
                            )}
                            {uploadInProgress && (
                                <div className="p-mt-2">
                                    <small><i className="pi pi-spin pi-spinner"></i> Uploading data...</small>
                                </div>
                            )}
                        </div>
                    </div>

                    {this.renderValidationErrorsTable()}
                    {this.renderResultsTable()}
                </Card>

                {this.renderTransactionHistory()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    orgId: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo.orgId : null,
    academicYearList: state.admissions && state.admissions.academicYearList ? state.admissions.academicYearList : []
});

export default connect(mapStateToProps)(FinanceBulkUpload);
